import * as React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const StatsIcon = ({ fill = 'black', size = 'xsmall' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    return (
        <svg
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox={`0 0 94 94`}
        >
            <title>Stats Icon</title>
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M50.917 23.5a7.833 7.833 0 0 1 7.833 7.833v47a7.834 7.834 0 0 1-7.833 7.834h-7.834a7.834 7.834 0 0 1-7.833-7.834v-47a7.834 7.834 0 0 1 7.833-7.833h7.834ZM19.584 39.166A7.834 7.834 0 0 1 27.417 47v31.334a7.833 7.833 0 0 1-7.833 7.833H11.75a7.833 7.833 0 0 1-7.833-7.833V47a7.834 7.834 0 0 1 7.833-7.833h7.834ZM82.251 7.833a7.834 7.834 0 0 1 7.833 7.833v62.667a7.833 7.833 0 0 1-7.833 7.833h-7.834a7.833 7.833 0 0 1-7.833-7.833V15.666a7.833 7.833 0 0 1 7.833-7.833h7.834Zm-70.501 70.5h7.834V47H11.75v31.334Zm31.333 0h7.834v-47h-7.834v47Zm31.334 0h7.834V15.666h-7.834v62.667Z"
                className={fillStyles}
            />
        </svg>
    );
};
